var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPlaybackIcon = function SvgPlaybackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "playback-icon_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4797"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2507"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 25",
    d: "M19.019 28H5.944A6.024 6.024 0 010 21.913V6.087A6.024 6.024 0 015.944 0h13.075a6.024 6.024 0 015.944 6.087v15.826A6.024 6.024 0 0119.019 28zM5.363 10.275a.6.6 0 00-.594.609V17.9a.6.6 0 00.594.609.575.575 0 00.289-.078l5.411-3.095v2.567a.6.6 0 00.594.609.577.577 0 00.289-.078l6.131-3.511a.616.616 0 000-1.063l-6.131-3.516a.574.574 0 00-.289-.078.6.6 0 00-.594.609v2.566l-5.41-3.1a.575.575 0 00-.29-.066z",
    transform: "translate(6.638 3.5)",
    fill: "url(#playback-icon_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2505"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2506"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 734",
    transform: "translate(3.016 3.5)",
    stroke: "#000",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.968,
    height: 28,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27.968,
    height: 27,
    rx: 4.5
  }))))))));
};
export default SvgPlaybackIcon;